import { useThemeMode } from '@/components/astryx-providers';
import { IconButton } from '@astryxdesign/core/IconButton';
import { Moon, Sun } from 'lucide-react';

const ThemeSwitcher = () => {
  const { mode, setMode } = useThemeMode();
  const isDark =
    mode === 'dark' ||
    (mode === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  const toggleTheme = () => {
    setMode(isDark ? 'light' : 'dark');
  };

  return (
    <IconButton
      label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      icon={isDark ? <Sun /> : <Moon />}
      variant="ghost"
      onClick={toggleTheme}
    />
  );
};

export default ThemeSwitcher;
